import { EstadoChip } from './EstadoChip'
import { ESTADOS_F11, EstadoF11, estadoLabel, t, Lang } from './i18n'

export function ContextMenuEstado({
  x,
  y,
  actual,
  lang,
  onSelect,
  onClose,
}: {
  x: number
  y: number
  actual: string | null
  lang: Lang
  onSelect: (estado: EstadoF11 | null) => void
  onClose: () => void
}) {
  const menuWidth = 220
  const menuHeight = 280
  const left = Math.min(x, Math.max(8, window.innerWidth - menuWidth - 8))
  const top = Math.min(y, Math.max(8, window.innerHeight - menuHeight - 8))

  return (
    <>
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, zIndex: 100 }}
      />
      <div
        role="menu"
        style={{
          position: 'fixed',
          top,
          left,
          width: menuWidth,
          maxHeight: menuHeight,
          overflowY: 'auto',
          zIndex: 101,
          background: 'var(--color-surface-card)',
          color: 'var(--color-text-primary)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-md)',
          padding: 8,
        }}
      >
        <strong>{t('markarSaioa', lang)}</strong>
        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {ESTADOS_F11.map((estado) => (
            <li key={estado}>
              <button onClick={() => onSelect(estado)} style={{ minHeight: 44, width: '100%', justifyContent: 'flex-start', gap: 8, marginTop: 4 }}>
                {actual === estado ? '✓ ' : ''}
                <EstadoChip estado={estado} /> {estadoLabel(estado, lang)}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => onSelect(null)}
              disabled={actual === null}
              style={{ minHeight: 44, width: '100%', justifyContent: 'flex-start', gap: 8, marginTop: 4 }}
            >
              <span aria-hidden="true">·</span> {t('sinMarcar', lang)}
            </button>
          </li>
        </ul>
      </div>
    </>
  )
}
